import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { getSeoForPath } from "../config/seo";

const Seo = () => {
  const { pathname } = useLocation();
  const { title, description, canonical } = getSeoForPath(pathname);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default Seo;
